<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
<div
	class="multi-check-menu-options px-3"
	#dropdownBlock
	[style.width]="dropdownWidth + 'px'"
	*ngIf="dropdownData"
>
	<!-- Header -->
	<h5 class="d-flex mx-0 my-1 no-selection align-items-center">
		{{ dropdownData.title }}
		<ng-container *ngIf="value">
			<span class="spacer"></span>

			<!-- Select all -->
			<span
				class="mx-1"
				role="button"
				ngTooltip="Select All Options"
				[popperOptions]="tooltipPopperOptions"
				*ngIf="value.length < dropdownData.maxSelect"
			>
				<ng-fa-icon
					class="d-inline-flex"
					[iconStyle]="EnumNgFaStyle.Solid"
					icon="check-double"
					(click)="selectAll()"
				></ng-fa-icon>
			</span>

			<!-- Deselect all -->
			<span
				class="mx-1"
				role="button"
				ngTooltip="Deselect All Options"
				[popperOptions]="tooltipPopperOptions"
				*ngIf="value.length >= dropdownData.maxSelect"
			>
				<ng-fa-icon
					class="d-inline-flex"
					[iconStyle]="EnumNgFaStyle.Solid"
					icon="xmark"
					(click)="deselectAll(); emitUpdated()"
				></ng-fa-icon>
			</span>

			<!-- Reset to default -->
			<span
				class="mx-1"
				role="button"
				ngTooltip="Restore to default"
				[popperOptions]="tooltipPopperOptions"
			>
				<ng-fa-icon
					class="d-inline-flex"
					[iconStyle]="EnumNgFaStyle.Solid"
					icon="arrow-rotate-left"
					(click)="restoreDefaults()"
				></ng-fa-icon>
			</span>

			<!-- Selected options count -->
			<span
				class="mx-1"
				ngTooltip="{{ value.length }} options selected out of {{ dropdownData.maxSelect }} options"
				[popperOptions]="tooltipPopperOptions"
			>
				{{ value.length }}/{{ dropdownData.maxSelect }}
			</span>
		</ng-container>
	</h5>
	<small class="text-muted no-selection">{{ dropdownData.description }}</small>
	<hr />

	<!-- Dropdown List-->
	<ng-container *ngIf="value && dropdownData?.options">
		<div
			class="no-selection"
			*ngFor="let option of dropdownData.options; let i = index"
		>
			<!-- Section title -->
			<h6 class="my-1">{{ option.title | titlecase }}</h6>

			<!-- section item -->
			<div
				*ngFor="let subOption of option.options"
				(click)="$event.stopPropagation(); selectedLabel.click()"
				class="ps-2 pe-1 py-1 menu-item cursor-pointer"
				[class.limit-by-disable]="value.length === dropdownData.maxSelect && !subOption.selected"
				[ngTooltip]="
					value.length === dropdownData.maxSelect && !subOption.selected ? 'maximum options selected' : ''
				"
				[popperOptions]="tooltipPopperOptions"
				ngbDropdownItem
			>
				<label
					for="{{ option.title | lowercase }}_{{ subOption.code | lowercase }}_{{ DROPDOWN_ID }}"
					class="pe-none"
					#selectedLabel
				>
					<input
						type="checkbox"
						class="form-check-input form-check-alignment"
						id="{{ option.title | lowercase }}_{{ subOption.code | lowercase }}_{{ DROPDOWN_ID }}"
						[(ngModel)]="subOption.selected"
						(ngModelChange)="emitUpdated()"
						[disabled]="value.length === dropdownData.maxSelect && !subOption.selected"
					/>

					{{ subOption.name }}
				</label>

				<span
					ngPreventClickPropagation
					*ngIf="subOption.description"
				>
					<ng-info-popover
						[title]="subOption.name"
						[message]="subOption.description"
						[options]="{ containerPosition: '-' }"
					></ng-info-popover>
				</span>
			</div>

			<!-- </div> -->
			<hr *ngIf="i < dropdownData.options.length - 1" />
		</div>
	</ng-container>
</div>
